/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
import React from "react";
import { Modal, LegacyStack } from "@shopify/polaris";
import { useSelector, useDispatch } from "react-redux";
import { setIsModalxOpen, setDestroy } from "./modalx.slice";
import OrderReleaseForm from "containers/orders/release-form/release.form";
import SignatureModal from "containers/orders/signature-modal/signature.modal";

function Modalx() {
  const {
    title,
    isOpen,
    component,
    primaryAction,
    secondaryActions,
    size,
    componentProps,
  } = useSelector((state) => state.modalxReducer);
  const dispatch = useDispatch();

  const closeModal = (e) => {
    if (e?.target) {
      dispatch(setIsModalxOpen(false));
      dispatch(setDestroy());
    }
  };

  const components = {
    OrderReleaseForm,
    SignatureModal
  };

  const ComponentNode = components[component];
  if (!ComponentNode) return null;
  return (
    <Modal
      title={title || null}
      primaryAction={primaryAction || null}
      secondaryActions={secondaryActions || null}
      open={isOpen}
      onClose={closeModal}
      size={size}
    >
      <Modal.Section>
        <LegacyStack vertical>
          <ComponentNode {...componentProps} />
        </LegacyStack>
      </Modal.Section>
    </Modal>
  );
}

export default Modalx;
